export default __webpack_public_path__ + "static/media/sasktel.3e149e13.png";